import service from "Utility/Service";
// import React from "react";
import { useMutation } from "react-query";
import { AxiosRequestConfig } from "axios";

// export const useLogin = () => {
//   // const queryClient = useQueryClient();
//   return useMutation((props: any) => {
//     const { values } = props;
//     const config: AxiosRequestConfig = {
//       method: "post",
//       url: "api/login",
//       data: { name: values.name, password: values.password },
//     };
//     return service(config);
//   });
// };

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/*  此函數用於處理用戶登錄。用於一個對象props作為參數，並從中提取values屬性。
    HTTP方法設置為"post"，URL設置為"/login"，數據包含用戶憑據（名稱和密碼）。
    將用戶身份驗證資訊發送到伺服器*/
export const useLogin = () => {
  // const queryClient = useQueryClient();
  return useMutation((props: any) => {
    const { values } = props;
    const config: AxiosRequestConfig = {
      method: "post",
      url: "/login",
      data: { user: { name: values.name, password: values.password } },
      // url: "login",
      // data: {  name: values.name, password: values.password  },
    };
    return service(config);
  });
};

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/*函數類似於useLogin，但設計用於處理用戶登出。
  它還使用useMutation鉤子，為"/logout" URL創建了一個"post"請求的Axios請求配置。
  同樣，使用service函數執行實際的HTTP請求。

*/
export const useLogout = () => {
  // const queryClient = useQueryClient();
  return useMutation(() => {
    // const {values} = props
    const config: AxiosRequestConfig = {
      method: "post",
      url: "/logout",
      // data: { user: { name: values.name, password: values.password } },
    };
    return service(config);
  });
};

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
